import RenderOnlyInBrowser from "../RenderOnlyInBrowser";
import CheckboxList from "./CheckboxList.client";

export default function ({
  productPropertyFilter,
  title,
  onValuesChange = Function(),
}) {
  if (import.meta.env.SSR) return null;

  const params = new URLSearchParams(document.location.search);
  const key = `filter[properties][${productPropertyFilter.name}]`;
  const checked = params.get(key)?.split(",") || [];

  const values = productPropertyFilter.values.map(({ value, presentation, filter_param }) => ({
    label: value,
    value: filter_param,
  }));
  
  return (
    <RenderOnlyInBrowser>
      <CheckboxList
        title={productPropertyFilter.presentation}
        values={values}
        checked={checked}
        name={key}
        onValuesChange={onValuesChange}
      />
    </RenderOnlyInBrowser>
  );
}
